import { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';

import Checkbox from '../Checkbox';

const ZoneSelector = ({ handleChange, selectedZones, zoneList }) => {
  const [selectZoneList, setSelectZoneList] = useState([]);
  const [selectAllList, setSelectAllList] = useState([]);
  const [currentScrollTop, setCurrentScrollTop] = useState(0);
  const listRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (listRef.current) {
        setCurrentScrollTop(listRef.current.scrollTop);
      }
    };

    const currentListRef = listRef.current;

    if (currentListRef) {
      currentListRef.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (currentListRef) {
        currentListRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (selectZoneList.length === 0 && selectedZones) {
      let newSelectedZones = [];

      selectedZones.map((zone) => {
        newSelectedZones.push(zone);
        setSelectZoneList(newSelectedZones);
      });
    }
  }, [selectedZones]);

  useEffect(() => {
    handleChange(null, 'selectedZones', selectZoneList);
  }, [selectZoneList]);

  function handleZoneSelect(zone) {
    if (selectZoneList.includes(zone)) {
      // If zone is already in the list, remove it
      setSelectZoneList((prevList) => prevList.filter((item) => item !== zone));
    } else {
      // If zone is not in the list, add it
      setSelectZoneList((prevList) => [...prevList, zone]);
    }
  }

  //select all by BUILDING
  function handleSelectAll(e, building) {
    let tempZoneList = [];
    building.thermalZones.map((zone) => {
      tempZoneList.push(zone.thermalZoneEntityKey);
    });

    if (selectAllList.includes(building.buildingShortDescription)) {
      // If building is already in the list, remove it
      setSelectAllList((prevList) =>
        prevList.filter((item) => item !== building.buildingShortDescription)
      );
    } else {
      // If building is not in the list, add it
      setSelectAllList((prevList) => [...prevList, building.buildingShortDescription]);
    }

    if (e.target.checked) {
      if (selectZoneList.length === 0) {
        setSelectZoneList([...selectZoneList, ...tempZoneList]);
      } else {
        let newList = [];
        newList.push(...selectZoneList, ...tempZoneList);

        setSelectZoneList(() => newList.filter((item) => !selectZoneList.includes(item.id)));
      }
    } else {
      setSelectZoneList((prevItems) => prevItems.filter((item) => !tempZoneList.includes(item)));
    }
  }

  return (
    <ZonePicker>
      <div className="zone-container" ref={listRef}>
        <div className="title">
          Select Zones:{' '}
          <span>
            {selectZoneList.length === 0
              ? 'Choose one or more'
              : `${selectZoneList.length} selected`}
          </span>
        </div>

        <div className="zone-items">
          {zoneList &&
            zoneList.map((building) => (
              <div
                className={`building-${building.buildingIndex}-group-items`}
                key={building.buildingIndex}
              >
                <div className="group-container list-item">
                  <div className="group-label">{building.buildingShortDescription}</div>
                </div>

                <div className="select-all" key={`${building.buildingIndex}-select-all`}>
                  <Checkbox
                    id={`${building.buildingIndex}-select-all`}
                    name={`${building.buildingIndex}-select-all`}
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e, building)}
                    checked={selectAllList.includes(building.buildingShortDescription)}
                  />
                  Select all in {building.buildingShortDescription}
                </div>

                <hr />

                {building.thermalZones.map((zone) => (
                  <div
                    className="zone-item list-item"
                    key={zone.thermalZoneEntityKey}
                    onClick={() => handleZoneSelect(zone.thermalZoneEntityKey)}
                  >
                    <input
                      id={zone.thermalZoneEntityKey}
                      type="checkbox"
                      checked={selectZoneList.includes(zone.thermalZoneEntityKey)}
                      onChange={() => handleZoneSelect(zone.thermalZoneEntityKey)}
                    />
                    <span className="zone-checkmark"></span>

                    {zone.thermalZoneShortDescription}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </ZonePicker>
  );
};

const ZonePicker = styled.div`
  hr {
    margin: 6px 0;
  }

  .zone-container {
    align-items: flex-start;
    border: 1px solid #eaecf0;
    border-radius: 8px;
    color: #02222b;
    display: flex;
    flex-flow: column;
    height: 245px;
    max-width: 628px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    width: 100%;

    .title {
      background: #f2f4f7;
      font-size: 12px;
      font-weight: 500;
      padding: 10px 14px;
      position: sticky;
      top: 0;
      width: 100%;
      z-index: 10;

      span {
        font-style: oblique;
      }
    }

    .zone-items {
      width: 100%;

      .select-all {
        color: #02222b;
        display: flex;
        gap: 6px;
        padding: 6px 12px 0;

        input {
          accent-color: #12b76a;
        }
      }
    }
  }

  .group-items {
    display: flex;
    flex-flow: column;
  }

  .group-container,
  .group-container {
    align-items: center;
    background: #f9fafb;
    border-bottom: 1px solid #eaecf0;
    display: flex;
    justify-content: space-between;
  }

  .expand {
    padding-right: 12px;

    img {
      height: 16px;
      transition: ease-in-out all 250ms;
      width: 16px;
    }
  }

  .weekdays-group-items.hidden,
  .weekends-group-items.hidden {
    .expand img {
      transform: rotate(180deg);
    }

    .day-item {
      display: none;
    }
  }

  .list-item {
    align-items: center;
    border-bottom: 1px solid #eaecf0;
    display: flex;
    font-weight: 600;
    padding: 10px 12px;
    width: 100%;
  }

  .zone-item {
    padding-left: 38px;
  }

  .list-item:last-of-type,
  .group-items:last-of-type {
    border-bottom: none;
  }

  .date-range label {
    border: none;
    line-height: 2;
    padding: 14px 0 0;
  }

  //Checklist styles
  .list-item input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  .list-item .zone-checkmark {
    align-items: center;
    background-color: #eaecf0;
    border: solid 1px #eaecf0;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 10px;
    width: 16px;
  }

  .list-item:hover input ~ .zone-checkmark {
    filter: brightness(0.85);
  }

  input:checked ~ .zone-checkmark {
    background-color: #d1fadf;
    border: solid 1px #12b76a;
    border-radius: 4px;
  }

  .zone-checkmark:after {
    content: '';
    position: unset;
    display: none;
  }

  input:checked ~ .zone-checkmark:after {
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    border: solid #12b76a;
    border-width: 0 3px 3px 0;
    display: block;
    height: 8px;
    margin-bottom: 4px;
    transform: rotate(45deg);
    width: 4px;
  }
`;

export default ZoneSelector;
